import { render, staticRenderFns } from "./carousel-product-slide-component.vue?vue&type=template&id=1f81d09e"
import script from "./carousel-product-slide-component.vue?vue&type=script&lang=js"
export * from "./carousel-product-slide-component.vue?vue&type=script&lang=js"
import style0 from "./carousel-product-slide-component.vue?vue&type=style&index=0&id=1f81d09e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports